import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api, publicFileUrl } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, GitCompareArrows } from "lucide-react";
import { Button } from "@/components/ui/button";
import GironeBadge from "@/components/GironeBadge";

const SHIELD_PLACEHOLDER = "https://images.unsplash.com/photo-1577214322326-5b31d9d886b0?crop=entropy&cs=srgb&fm=jpg&w=300&q=80";

export default function Squadre() {
  const [teams, setTeams] = useState([]);
  useEffect(() => { api.get("/public/teams").then(({ data }) => setTeams(data)).catch(() => {}); }, []);
  const by = { A: [], B: [], C: [], D: [] };
  teams.forEach((t) => by[t.girone]?.push(t));

  return (
    <div className="App">
      <Header />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 space-y-6">
        <div className="fade-up flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center"
               style={{ background: "rgba(204,255,0,0.15)", color: "var(--brand)" }}>
            <Users className="w-6 h-6" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs uppercase tracking-widest text-slate-500">Roster ufficiale</div>
            <h1 className="display font-black text-4xl md:text-5xl">Le Squadre</h1>
          </div>
          <Link to="/confronto" data-testid="squadre-confronto-link">
            <Button variant="outline" className="rounded-full border-slate-300">
              <GitCompareArrows className="w-4 h-4 mr-1.5" /> Confronta
            </Button>
          </Link>
        </div>
        <p className="text-slate-500 max-w-2xl hidden">
          Le 32 squadre iscritte a Fantacalcio FIFE 2026/27 divise nei quattro gironi.
        </p>

        <Tabs defaultValue="A">
          <TabsList className="bg-slate-50 border border-slate-200 w-full sm:w-auto grid grid-cols-4 sm:inline-flex">
            {["A", "B", "C", "D"].map((g) => (
              <TabsTrigger key={g} value={g} className="data-[state=active]:bg-[var(--brand)] data-[state=active]:text-white inline-flex items-center gap-1.5 px-2 sm:px-3"
                           data-testid={`squadre-tab-${g}`}>
                <GironeBadge girone={g} size={18} />
                <span className="hidden sm:inline">Girone</span>
              </TabsTrigger>
            ))}
          </TabsList>
          {["A", "B", "C", "D"].map((g) => (
            <TabsContent key={g} value={g} className="mt-6">
              {by[g].length === 0 ? (
                <div className="card-surface rounded-2xl p-8 text-center text-slate-500">
                  Girone {g}: nessuna squadra ancora approvata.
                </div>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 stagger">
                  {by[g].map((t) => (
                    <Link key={t.user_id} to={`/squadra/${t.user_id}`}
                          className="card-surface rounded-2xl p-3 card-lift block group"
                          data-testid={`squadre-card-${t.user_id}`}>
                      <div className="aspect-square bg-slate-50 rounded-xl overflow-hidden mb-3">
                        <img src={t.shield_path ? publicFileUrl(t.shield_path) : SHIELD_PLACEHOLDER}
                             onError={(e) => { e.currentTarget.src = SHIELD_PLACEHOLDER; }}
                             alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                      </div>
                      <div className="display font-bold text-sm truncate">{t.team_name}</div>
                      <div className="text-slate-500 text-xs truncate">{t.coach_name}</div>
                      <div className="mt-1 flex items-center gap-1.5">
                        <GironeBadge girone={t.girone} size={16} />
                        <span className="text-slate-500 text-[10px] uppercase tracking-widest font-bold">Girone</span>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      </div>
      <Footer />

    </div>
  );
}
